import { useEffect, useState } from "react";
import axios from "axios";
import Marquee from "react-fast-marquee";
import "../assets/css/partners.css";

export default function PartnerBanners() {
    const [partners, setPartners] = useState([]);
    // const apiUrl = "https://aed.mju.ac.th/api/arch/";
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await axios.get(`${apiUrl}partners/index.json`);
                const items = result.data.partnerBanner || result.data;
                if (Array.isArray(items) && items.length > 0) {
                    setPartners(items);
                }
            } catch (e) {
                console.error("fetch Partner ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);
    // console.log("Partners: ", partners);

    // console.log("partnerBanners:",partnerBanners);
    const genPartnerBanners = partners.map((item, index) => {
        // return <a href={item.imgLink} target="_blank" rel="noreferrer"><img key={`imgPartner${index}`} src={item.imgSrc} alt={item.imgAlt} /></a>;
        return <a key={`partner-${index}`} href={item.imgLink} target="_blank" rel="noreferrer"><img src={item.imgSrc} alt={item.imgAlt} /></a>;
    });

    return (
        <div key={"partnersHolder"} id="partnersHolder">
            <Marquee
                behavior="scroll"
                direction="left"
                id="myMarquee"
                pauseOnHover={true}
                speed={50}
                gradient={true}
                gradientWidth="40px"
            >
                {/* <img src="../assets/images/partners/logo_b.png" alt={"abc"} />abv */}
                {genPartnerBanners}
            </Marquee>
        </div>
    );
}
